import { applyPageMetadata } from "@/lib/page-metadata";
import { createFileRoute } from "@tanstack/react-router";
import { Layout, Section, Eyebrow, Breadcrumbs, CTAButton, BOOKING_URL } from "@/components/site/Layout";
import { HubSpotForm } from "@/components/site/HubSpotForm";
import { breadcrumbSchema, jsonLdScript, organizationSchema } from "@/lib/seo";

export const Route = createFileRoute("/contact")({
  head: () => applyPageMetadata("/contact", {
    meta: [
      { title: "Contact PageOne Lawyers | Book a Strategy Call" },
      { name: "description", content: "Book a strategy call with a senior SEO strategist who actually understands law firm economics." },
      { property: "og:title", content: "Contact | PageOne Lawyers" },
      { property: "og:description", content: "Talk to a senior strategist about your firm's SEO." },
      { property: "og:url", content: "https://pageonelawyers.com/contact" },
    ],
    links: [{ rel: "canonical", href: "https://pageonelawyers.com/contact" }],
    scripts: [
      jsonLdScript(organizationSchema()),
      jsonLdScript(breadcrumbSchema([
        { label: "Home", path: "/" },
        { label: "Contact", path: "/contact" },
      ])),
    ],
  }),
  component: Contact,
});

function Contact() {
  return (
    <Layout>
      <section className="bg-hero-gradient text-primary-foreground">
        <div className="mx-auto max-w-7xl px-5 py-12 sm:px-6 sm:py-16">
          <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Contact" }]} />
          <Eyebrow><span className="text-[var(--gold)]">Contact</span></Eyebrow>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl md:text-6xl font-semibold">Let's talk about your firm.</h1>
        </div>
      </section>
      <Section>
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="font-display text-3xl font-semibold">Book a strategy call.</h2>
            <p className="mt-4 text-muted-foreground leading-relaxed">A 20-minute call with a senior strategist (not an SDR). We'll discuss your firm's practice mix, target markets, current SEO state, and whether we're the right fit. No pitch deck. No pressure.</p>
            <div className="mt-6">
              <CTAButton to={BOOKING_URL} variant="gold">Pick a time that works for you</CTAButton>
            </div>
            <div className="mt-8 space-y-4 text-sm">
              <div><span className="font-semibold">Email:</span> <a href="mailto:contact@pageonelawyers.com" className="hover:text-[var(--gold-deep)] transition">contact@pageonelawyers.com</a></div>
              <div><span className="font-semibold">Response time:</span> Within 1 business day</div>
              <div><span className="font-semibold">Service area:</span> United States, United Kingdom, Canada, Australia</div>
            </div>
          </div>
          <div className="min-w-0 overflow-hidden rounded-xl bg-card border border-border p-4 sm:p-8">
            <h2 className="font-display text-2xl font-semibold mb-4">Send us a message</h2>
            <HubSpotForm />
          </div>
        </div>
      </Section>
    </Layout>
  );
}